import { none, State } from "@hookstate/core";
import { Validation, ValidationError } from "@hookstate/validation";

type Identifiable = {
    id: string
}

export function addElement<T>(elementStates: State<T[]>, element: T) {
    elementStates.merge([element])
}

export function removeElementById<T extends Identifiable>(elementStates: State<T[]>, elementId: string) {
    const elementIndex = elementStates.get().findIndex(element => element.id === elementId)
    if (elementIndex >= 0) {
        elementStates[elementIndex].set(none)
    }
}

export function getElementFieldValue<T>(elementState: State<T>, fieldName: string) {
    return elementState[fieldName as keyof State<T>].get()
}

export function makeSetHandler<T>(elementState: State<T>, fieldName: string) {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
        elementState[fieldName as keyof State<T>].set(event.target.value)
    }
}

export function makeCheckHandler<T>(elementState: State<T>, fieldName: string) {
    return (event: React.ChangeEvent<HTMLInputElement>) => {
        elementState[fieldName as keyof State<T>].set(event.target.checked)
    }
}

export function makeSetHandlerPlain<T>(elementState: State<T>, fieldName: string) {
    return (value: unknown) => {
        elementState[fieldName as keyof State<T>].set(value)
    }
}

export function makeValidationHandler<T>(elementState: State<T>, fieldName: string) {
    return () => Validation(elementState[fieldName as keyof State<T>]).errors()
}

export function hasError(lang: string, validationError: ValidationError) {
    const fieldName = validationError.path ? validationError.path[validationError.path.length - 1] as string : ''
    if (lang === 'En') {
        return !fieldName.endsWith('De')
    }
    return fieldName.endsWith(lang)
}

export function hasErrors(lang: string, entityState?: State<any>) {
    if (entityState) {
        const validationErrors = Validation(entityState).errors()
        // console.log(validationErrors)
        return validationErrors.some((validationError) => hasError(lang, validationError))
    }
    return false
}

export function hasErrorsAll(entityState?: State<any>) {
    return hasErrors('En', entityState) || hasErrors('De', entityState)
}
